/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateDishLikeNotificationBodyRequest } from '../../models/update-dish-like-notification-body-request';

export interface PatchLikesByDishidUpdateNotification$Params {
  DishId: number;
  body: UpdateDishLikeNotificationBodyRequest;
}

export function patchLikesByDishidUpdateNotification(
  http: HttpClient,
  rootUrl: string,
  params: PatchLikesByDishidUpdateNotification$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, patchLikesByDishidUpdateNotification.PATH, 'patch');
  if (params) {
    rb.path('DishId', params.DishId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    }),
  );
}

patchLikesByDishidUpdateNotification.PATH = '/Authentication/likes/{DishId}/update-notification';
